import React, { Fragment } from "react";
import { getNameFromPackageId, MenuProps } from "../../../../utils/constants";
import {
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  OutlinedInput,
  Chip,
} from "@mui/material";
import { ErrorMessage } from "formik";

const PackageInfo = ({ ...props }) => {
  const {
    emailTemplates,
    packages,
    errors,
    touched,
    values,
    handleSelectChange,
    setFieldValue,
    classes,
    checked,
    handleCheck,
  } = props;

  return (
    <Fragment>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography variant="h4" gutterBottom>
            Package Info
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormControlLabel
            className={classes.checkbox}
            control={
              <Checkbox
                checked={checked}
                onChange={(e) => handleCheck(e, setFieldValue, "checked")}
                name="sendEmail"
                color="primary"
              />
            }
            label="Send email automatically?"
          />
        </Grid>
        <Fragment>
          {checked && (
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth margin="normal">
                <InputLabel id="emailTemplateId-label">
                  Email Templates
                </InputLabel>
                <Select
                  labelId="emailTemplateId-label"
                  id="emailTemplateId"
                  name="emailTemplateId"
                  label="Email Templates"
                  error={
                    errors.emailTemplateId && touched.emailTemplateId
                      ? true
                      : false
                  }
                  value={values.emailTemplateId}
                  onChange={(e) =>
                    handleSelectChange(e, setFieldValue, "emailTemplateId")
                  }
                >
                  {emailTemplates &&
                    emailTemplates.map((emailTemplate) => (
                      <MenuItem key={emailTemplate.id} value={emailTemplate.id}>
                        {emailTemplate.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <ErrorMessage name="emailTemplateId">
                {(msg) => <div className="error error-message">{msg}</div>}
              </ErrorMessage>
            </Grid>
          )}
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth margin="normal">
              <InputLabel id="packageIds-label">Packages</InputLabel>
              <Select
                labelId="packageIds-label"
                id="packageIds"
                error={errors.packageIds && touched.packageIds ? true : false}
                multiple
                value={values.packageIds}
                onChange={(e) =>
                  handleSelectChange(e, setFieldValue, "packageIds")
                }
                input={<OutlinedInput id="select-multiple-chip" label="Packages" />}
                renderValue={(selected) => (
                  <div className={classes.chips}>
                    {selected.map((value, index) => (
                      <Chip
                        key={`${value}-${index}`}
                        label={getNameFromPackageId(value, packages)}
                        className={classes.chip}
                      />
                    ))}
                  </div>
                )}
                MenuProps={MenuProps}
              >
                {packages &&
                  packages.map((_package) => (
                    <MenuItem key={_package.id} value={_package.id}>
                      {_package.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <ErrorMessage name="packageIds">
              {(msg) => <div className="error error-message">{msg}</div>}
            </ErrorMessage>
          </Grid>
        </Fragment>
      </Grid>
    </Fragment>
  );
};

export default PackageInfo;
